<template lang="html">
  <div class="app">
    <div class=""><Navber></Navber></div>
      <div class="container mt-5" style="background: white;">
        <div class="row"><h1 class="text-left header pl-5 pt-5" style="">Ambee AutoML</h1></div>
        <p class="text-left pl-4 ml-2 pt-3 text-muted" style="font-size: 1.1rem;">Build custom high quality machine learning models  even with limited machine learning expertise and fraction of your effort</p>
        <div class="text-left pl-4 ml-2 pt-3"><button class="btn-primary btn-lg px-5" @click="routeToLogin" style="font-size: 1.1rem;">Try Now</button></div>
        <div class="row">
          <div class="col-sm-8 text-left pl-5" style="padding-top: 4rem;">
            <h2 class="pt-2 border-bottom header" style="width: fit-content;font-size: 2.2rem !important">Autonomous artificial intelligence</h2>
          </div>
        </div>
        <div class="row border-none justify-content-between">
          <div class="col-sm-12 col-md-7 p-3 pl-5 text-left">
            <p style="line-height: 2rem">Ambee AutoML is a suite of machine learning products that enables developers with limited machine learning expertise to train high-quality models specific to Environment, IOT devices data, Weather, Air quality, Energy, Satellite Imagery, Object detection from Satellite Images and lots more. On our roadmap, we intend to build a state-of-the-art transfer learning and neural architecture learning technology</p>
          </div>
          <div class="col-sm-12 col-md-4 pr-5">
            <img src="../assets/autonumus.jpg" class="paddingleft p-0 border-none img-thumbnail" />
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-sm-12 col-md-4 pl-5">
            <img src="../assets/perfor.jpg" class="p-0 border-none img-thumbnail paddingRight" />
          </div>
          <div class="col-sm-12 paddingleft col-md-8 pr-5 py-3 text-left">
            <h2 class="text-left">Best Performance</h2>
            <p style="line-height: 2rem">Ambee AutoML leverages more than 10 years of environmental data, more than a year of proprietary Air quality data, weather data and data gathered from multiple sources to help your machine learning models achieve faster performance and more accurate predictions.</p>
          </div>
        </div>
        <div class="row p-3 mt-5">
          <div class="col-sm-12 paddingRight col-md-8 pl-5 text-left">
            <h2 class="text-left">Get up and running in no time</h2>
            <p style="line-height: 2rem">Using a very intuitive, simple graphical user interface to upload your data, train, evaluate, hyper-tune, improve and get the accurate results based on your data. We already have the necessities to build your own custom machine learning model quickly within few minutes.</p>
          </div>
          <div class="col-sm-12 paddingleft col-md-4 pr-5">
            <img src="../assets/notime.jpg" class="p-0 border-none img-thumbnail"  />
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-sm-12 col-md-4 pl-5">
            <img src="../assets/generate.jpg" class="p-0 border-none img-thumbnail paddingRight"  />
          </div>
          <div class="col-sm-12 col-md-8 pr-5 py-3 paddingleft text-left">
            <h2 class="text-left">Generate high-quality training data, high-quality forecasts</h2>
            <p style="line-height: 2rem">Ambee’s automated data-preprocessing, exploratory data analytics and dynamic handling of errors in the unstructured data, creating automated labels or even perform data encoding for categorical data, all of which is possible through Ambee AutoML.</p>
          </div>
        </div>
      <hr/>
      </div>
      <div class="mt-5 container">
        <h2 class="text-left header" style='font-size: 2.2rem'>AutoML Products</h2>
        <div class="row justify-content-around my-5">
          <div class="col-md-3 margin card p-0 col-sm-12 m-0 text-left">
            <img src="../assets/generic.png" alt="logo" class="p-0 border-none img-thumbnail" />
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">Generic Model</h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Create custom models or train new models on any time-series data, get forecasts, predictions</p>
             <span style="color: blue; text-decoration: underline" @click="routeToLogin" class="cursor-pointer pl-3 pb-4 mt-auto">Get Started</span>
          </div>
          <div class="col-md-3 margin p-0 m-0 card col-sm-12 text-left">
            <img src="../assets/satatlit.png" alt="logo" class="p-0 border-none img-thumbnail" />
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">SatSight</h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Derive insights from Satellite images using Ambee Cloud Infra or download and save models so you can run them on the edge.</p>
            <span style="color: blue; text-decoration: underline" class="cursor-pointer  pl-3 pb-4 mt-auto">Coming soon</span>
          </div>
          <div class="col-md-3 margin p-0 m-0 card col-sm-12 text-left">
            <img src="../assets/calibrated.jpg" alt="logo" class="p-0 border-none img-thumbnail" />
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">Caas <span class="subheading"> (Calibration as a Service)</span></h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Calibrate Air monitoring sensors on the cloud. Send your air monitor’s data through our model and get eBAM refrence grade data as output, realtime.</p>
            <span style="color: blue; text-decoration: underline" class="cursor-pointer  pl-3 pb-4 mt-auto">Coming soon</span>
          </div>
          <div class="col-md-3 margin mt-5 impborder p-0 cardss col-sm-12 text-left">
            <img src="../assets/detect.jpg" alt="logo" class="p-0 border-none img-thumbnail" />
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">Detect</h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Perform Object detection, roof top analysis for analysing solar power potential or guage depth or identify flora fauna from sat images.</p>
            <span style="color: blue; text-decoration: underline" class="cursor-pointer  pl-3 pb-4  mt-auto">Coming soon</span>
          </div>
          <div class="col-md-3 margin p-0 mt-5 card col-sm-12 text-left">
            <img src="../assets/viusalize.jpg" alt="logo" height="28" class="p-0 border-none img-thumbnail" />
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">EDA</h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Upload data, select variables and analyze and generate report with one click. Download and share the generated report.</p>
            <span style="color: blue; text-decoration: underline" class="cursor-pointer  pl-3 pb-4 mt-auto" @click="routeToLogin">Get Started</span>
          </div>
          <div class="col-md-3 margin p-0 mt-5 card col-sm-12 text-left">
            <img src="../assets/meteor.png" alt="logo" class="p-0 border-none img-thumbnail" />
            <h4 class="border-bottom pl-3 pr-4 pt-4 pb-2" style="font-size: 1.2rem;">Meteor</h4>
            <p class="pt-3 pr-4 pl-3 text-muted">Use Grib data to extract meaningful usable information for AOD (Aerosol optical detection) and download data in no time.</p>
            <span style="color: blue; text-decoration: underline" class="cursor-pointer  pl-3 pb-4 mt-auto">Coming soon</span>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
/* eslint-disable */
import Toasted from 'vue-toasted'
import Vue from 'vue'
import { apiCall } from '@/utils/api'
import Navber from './navbarLogin';

Vue.use(Toasted)
export default {
  name: "Landing",
  props: {
  },
  components: {
      Navber: Navber
  },
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    routeToLogin() {
      this.$router.push('/under-Maintenance')
    }
  }
}
</script>
<style scoped>
.impborder {
  border: 1px solid rgba(0,0,0,.125) !important;
}
.header {
  font-size: 48px;
  letter-spacing: -0.5px;
  line-height: 58px;
}
.fit-content {
  width: fit-content;
}
.subheading {
  font-size: 1rem;
    color: #a5a4a4;
}
.border-none {
  border: none; 
}
.box-shad {
    -webkit-box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
    -moz-box-shadow: 7px 7px 5px 0px rgba(50, 50, 50, 0.75);
    box-shadow: 1px 2px 1px 1px #cfd1de;
}
.blue {
  color: blue;
}
.white{
  color: white;
}
.cursor-pointer {
    cursor: pointer;
}
.box-shadow1{
  box-shadow: 0px 7px 6px 1px #cfd1de;
}
.margin {
  margin-left: 0.1rem;
  margin-right: 0.1rem;
}

@media screen and (max-width: 34em) {
  .paddingleft {
    padding-left: 2.5rem !important; 
  }
  .paddingRight {
    padding-right: 2.5rem !important;
  }
}
</style>
